import { LineaDeBolsa } from '../../../types';

// SPEC-168 (RN-002, RN-004): devuelve la PRIMERA línea de cada producto_id, preservando el orden de
// aparición. Base para las fotos de productos distintos de la franja y para contar "referencias"
// (número de productos diferentes, no total de líneas).
export function productosDistintos(lineas: LineaDeBolsa[]): LineaDeBolsa[] {
  const vistos = new Set<string>();
  const resultado: LineaDeBolsa[] = [];
  for (const l of lineas) {
    if (vistos.has(l.producto_id)) continue;
    vistos.add(l.producto_id);
    resultado.push(l);
  }
  return resultado;
}
